//
export default [
  {
      text: 'código interno',
      value: 'internal_code',
      width: '10%',
  },
  {
      text: 'nombre',
      value: 'name',
  },
  {
      text: 'cantidad',
      value: 'quantity',
      align: 'right',
      format: 'number',
      input: {
        reverse: true,
        type: 'float-field',
        trigger: trigger_discount,
      },
      width: '10%',
  },
  {
      text: 'precio neto',
      value: 'net_price',
      align: 'right',
      format: 'currency',
      input: {
        type: 'currency-field',
        reverse: true,
        trigger: trigger_discount,
      },
      width: '10%',
  },
  {
      text: 'descuento/recargo',
      value: 'global_discount_line_percentage',
      align: 'right',
      format: 'percentage',
      input: {
        type: 'float-field',
        reverse: true,
        prefix: '%',
        max: 100,
        trigger: trigger_discount,
      },
      width: '10%',
  },
  {
      text: 'total neto',
      value: 'net_total',
      align: 'right',
      format: 'currency',
      input: {
        type: 'currency-field',
        reverse: true,
        readonly: true,
        trigger: trigger_discount,
      },
      width: '10%',
  },
]

/**
 * Discount Trigger
 * @param {*} ctx 
 * @param {*} props 
 */
function trigger_discount (ctx, props) {

  //
  const { global_discount_line_percentage, net_price, quantity } = props.item
  const net_total = net_price * quantity
  const net_discount = net_total * global_discount_line_percentage / 100

  //
  props.item.global_discount_line_amount = net_discount
  props.item.net_total = Math.round(net_total - props.item.global_discount_line_amount)
}
